import { API_G_090_ZAIKO_IDO_IRAI_ENTRY } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_090: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getZaikoIdoIraiEntry(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_090_ZAIKO_IDO_IRAI_ENTRY,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getZaikoIdoIraiEntry error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async postZaikoIdoIraiEntry(_ctx, requestData) {
      try {
        const res = await axios({
          url: API_G_090_ZAIKO_IDO_IRAI_ENTRY,
          data: {
            requestData,
          },
          method: 'POST',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api postZaikoIdoIraiEntry error.');
        console.log(err);
      }
    },
    async getZaikoIdoIraiEntryItem(_ctx, params) {
      try {
        const {
          zaikoIdoIraiJigyoshoCd,
          zaikoIdoIraiEntryYmd,
          zaikoIdoIraiNo,
          zaikoIdoIraiShuseiCount,
        } = params;

        const res = await axios({
          url: `${API_G_090_ZAIKO_IDO_IRAI_ENTRY}/${zaikoIdoIraiJigyoshoCd}/${zaikoIdoIraiEntryYmd}/${zaikoIdoIraiNo}/${zaikoIdoIraiShuseiCount}`,
          method: 'GET',
          params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getZaikoIdoIraiEntryItem error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putZaikoIdoIraiEntryItem(_ctx, requestData) {
      try {
        const {
          zaikoIdoIraiJigyoshoCd,
          zaikoIdoIraiEntryYmd,
          zaikoIdoIraiNo,
          zaikoIdoIraiShuseiCount,
        } = requestData.zaikoIdoIraiData;

        const res = await axios({
          url: `${API_G_090_ZAIKO_IDO_IRAI_ENTRY}/${zaikoIdoIraiJigyoshoCd}/${zaikoIdoIraiEntryYmd}/${zaikoIdoIraiNo}/${zaikoIdoIraiShuseiCount}`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putZaikoIdoIraiEntryItem error.');
        console.log(err);
      }
    },
    async deleteZaikoIdoIraiEntryItem(_ctx, params) {
      try {
        const {
          zaikoIdoIraiJigyoshoCd,
          zaikoIdoIraiEntryYmd,
          zaikoIdoIraiNo,
          zaikoIdoIraiShuseiCount,
        } = params;

        const res = await axios({
          url: `${API_G_090_ZAIKO_IDO_IRAI_ENTRY}/${zaikoIdoIraiJigyoshoCd}/${zaikoIdoIraiEntryYmd}/${zaikoIdoIraiNo}/${zaikoIdoIraiShuseiCount}`,
          params,
          method: 'DELETE',
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api deleteZaikoIdoIraiEntryItem error.');
        console.log(err);
      }
    },
  },
};

export default g_090;
